import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { DateSollecitoDocumentazione } from "../models/date-sollecito-documentazione";
import { ResourcefulService } from "./resourcefulService";

@Injectable({
  providedIn: "root",
})
export class DateSollecitoDocumentazioneService extends ResourcefulService<DateSollecitoDocumentazione> {
  constructor(httpClient: HttpClient) {
    super(httpClient, DateSollecitoDocumentazione);
  }

  listByIncarico(incaricoId: number): Promise<DateSollecitoDocumentazione[]> {
    const params: any = {
      incarico_id: `${incaricoId}`,
    };

    return this._httpClient
      .get<{ data: any[] }>(`${this.baseUrl}/${DateSollecitoDocumentazione.apiUrl}`, {
        params,
      })
      .pipe(
        map((response) =>
          (response?.data || []).map((item) =>
            new DateSollecitoDocumentazione().deserialize(item)
          )
        )
      )
      .toPromise();
  }
}
